export const environment = {
	production: false,
	//baseUrl: "https://thecapitalhub.onrender.com",
	//baseUrl: "http://localhost:8080",  
	// baseUrl: "http://localhost:8001",
	// baseUrl: "https://api.thecapitalhub.in",
	baseUrl: "https://api2.thecapitalhub.in",
};

// export const LINKDIN = "https://www.linkedin.com/developers/apps/verification2c20194f-b5dd-4fe3-a1ce-715dd9aeb301"
